import type { ValidatedKey } from '@festina-life/core'
import { useField } from 'formik'
import get from 'lodash-es/get'
import { useMemo } from 'react'

import { useFormikContext } from '../../hooks/useFormikContext'
import { useExistingValuesContext } from '../../theme/existingValuesContext'

export const useNumericValueDifferenceCheck = (name: ValidatedKey) => {
  const [field] = useField(name)
  const {
    initialValues,
    status: { shouldShowChangesInForm },
  } = useFormikContext()

  const existingValue = useExistingValuesContext()?.getExistingValue?.(
    name,
  ) as string

  const initialValue = useMemo(
    () => get(initialValues, name),
    [initialValues, name],
  )

  return useMemo(() => {
    if (!shouldShowChangesInForm) {
      return undefined
    }

    const previous = existingValue ?? initialValue ?? 0
    const current = field.value ?? 0
    if (current > previous) {
      return 'bigger'
    } else if (current < previous) {
      return 'smaller'
    } else if (current === previous) {
      return 'identical'
    }
    return undefined
  }, [existingValue, field.value, initialValue, shouldShowChangesInForm])
}
